import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WidgetAuthErrorEnum } from './models/widget-auth-error.enum';
import { AnalyticResponseModel } from './models/analytic-response.model';
import { DeveloperAnalyticModel } from './models/developer-analytic.model';
import { UserAnalyticModel } from './models/user-analytic.model';

const formHeaders = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  })
};

@Injectable({
  providedIn: 'root'
})
export class WidgetAnalyticsService {
  constructor(
    private http: HttpClient
  ) { }

  /**
   * Validates the specified analytic id.
   */
  getAnalytic(analyticId: string): Observable<AnalyticResponseModel> {
    return this.http.get(`/ws/user/analytics?analytic_id=${analyticId}`)
      .pipe(
        map(() => ({ success: true })),
        catchError((response: HttpErrorResponse) => of(this.parseError(response)))
      );
  }

  /**
   * Sends an analytic and return the validation status.
   */
  sendAnalytic(analytic: UserAnalyticModel | DeveloperAnalyticModel): Observable<AnalyticResponseModel> {
    const request$ = analytic instanceof UserAnalyticModel
      // user analytic
      ? this.http.post(`/ws/user/analytics`, analytic, formHeaders)
      // developer analytic
      : this.http.post(`/ws/developer/apps/access/key`, analytic, formHeaders);

    return request$
      .pipe(
        map(() => ({ success: true })),
        catchError((response: HttpErrorResponse) => of(this.parseError(response)))
      );
  }

  private parseError(response: HttpErrorResponse): AnalyticResponseModel {
    const error = response.error.error;
    const status = response.status;
    // server error isn't an auth failure
    const success = status >= 500 && status <= 504;
    const message = error && error.message ? error.message : '';
    const errorCode = Object.values(WidgetAuthErrorEnum).includes(message) ? <WidgetAuthErrorEnum>message : null;
    return { success: success, message: message, errorCode: errorCode };
  }

}
